export default __webpack_public_path__ + "static/media/location.e0ec3767.svg";